



















































// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { SizeMap } from '../../../../../composables'

import { DashmixTheme } from '../../../contracts'

import { DashmixBadgeShape, DashmixButton, DashmixIconName, DashmixInput } from '../../atoms'

import { DashmixActionBadge } from '../ActionBadge'
import { DashmixDropdown } from '../Dropdown'
import { DashmixInputGroup } from '../InputGroup'

import { InputTypeahead } from './partials/InputTypeahead.vue'
import { typeaheadProps, useTypeahead } from './Typeahead.hook'
import { TypeaheadProps } from './Typeahead.contracts'

/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const DashmixTypeahead = defineComponent({
  name: 'DashmixTypeahead',
  components: {
    InputTypeahead,
    DashmixActionBadge,
    DashmixDropdown,
    DashmixInputGroup,
    DashmixInput,
    DashmixButton
  },
  props: typeaheadProps,
  emits: ['cleared', 'selected', 'searched', 'deleted'],
  setup (props: TypeaheadProps, ctx: SetupContext) {
    return {
      ...useTypeahead(props, ctx),
      badgeShapes: DashmixBadgeShape,
      colorTheme: DashmixTheme,
      icon: DashmixIconName,
      sizes: SizeMap
    }
  }
})

export default DashmixTypeahead
